import React from "react";
import { List, Checkbox, Dropdown, Button, message } from "antd";
import { HolderOutlined, TableOutlined } from "@ant-design/icons";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { saveGridSettings } from "../../../utils/globalService";

// Reorder helper
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const DragAndDropList = (props: any) => {
  const {
    columns,
    setModifiedColumns,
    changePicker,
    detectColumnChanges,
    screenName,
    filterStatus = "",
    hiddenFields = [],
    setGridReset = null,
  } = props;

  let allHeaders = Array.isArray(columns) ? [...columns] : [];

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const newItems: any = reorder(columns, result.source.index, result.destination.index);
    setModifiedColumns(newItems);
    changePicker && changePicker(true);
  };

  const toggleCheckbox = (event, id) => {
    setModifiedColumns((prev) => {
      const updated = prev.map((item) =>
        item.id == id ? { ...item, checked: !item.checked, hide: !item?.hide } : item
      );

      return updated;
    });
    changePicker && changePicker(true);
  };

  const saveGridChanges = async () => {
    let data = await saveGridSettings(screenName, columns, true);
    if (data?.length > 0) {
      setModifiedColumns(data);
      message.success("your changes saved successfully");
      changePicker(false);
    }
  };

  const dropdownContent = (
    <div
      style={{
        width: 250,
        maxHeight: 400, // total height including button
        maxWidth: 250,
        padding: 8,
        background: "#fcfcfc",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
        borderRadius: 6,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Scrollable list */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
        }}
      >
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable-list">
            {(provided) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                <List
                  dataSource={allHeaders}
                  renderItem={(column, index) => (
                    <Draggable key={(column as any)?.id} draggableId={(column as any).id?.toString()} index={index}>
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          style={{
                            marginBottom: 0,
                            ...provided.draggableProps.style,
                            display: ["action", ...hiddenFields].includes((column as any).field) ? "none" : undefined,
                          }}
                        >
                          <div
                            style={{
                              background: snapshot.isDragging ? "#fafafa" : "#fff",
                              padding: "10px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                flex: 1,
                              }}
                            >
                              <div>
                                <Checkbox
                                  checked={(column as any).checked}
                                  disabled={
                                    ((column as any).field === "renewalInviteSendOn" &&
                                      filterStatus !== "ready_to_send") ||
                                    ((column as any).field === "approvalType" && filterStatus === "hidden")
                                  }
                                  onChange={(e) => toggleCheckbox(e, (column as any)?.id)}
                                >
                                  <span
                                    style={
                                      (column as any).checked
                                        ? { marginLeft: "10px" }
                                        : {
                                            marginLeft: "10px",
                                            color: "lightgray",
                                          }
                                    }
                                  >
                                    {(column as any).headerName && (column as any).headerName != ""
                                      ? (column as any).headerName
                                      : (column as any).field}
                                  </span>
                                </Checkbox>
                              </div>

                              <span
                                {...provided.dragHandleProps}
                                style={{
                                  cursor: (column as any).checked ? "grab" : "none",
                                  fontSize: 18,
                                  color: "black",
                                }}
                              >
                                <HolderOutlined />
                              </span>
                            </div>
                          </div>
                        </div>
                      )}
                    </Draggable>
                  )}
                />
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>

      {/* Fixed Save button */}

      {detectColumnChanges && (
        <div
          style={{
            borderTop: "1px solid #eee",
            padding: "10px 0",
            background: "#ffffff",
            // textAlign: "left",
          }}
        >
          <div style={{ display: "flex", justifyContent: setGridReset ? "space-between" : "center" }}>
            <Button size="large" type="primary" onClick={() => saveGridChanges()}>
              Save
            </Button>

            {setGridReset && (
              <Button size="large" type="default" onClick={() => setGridReset(true)}>
                Reset
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );

  return (
    <Dropdown overlay={dropdownContent} trigger={["click"]} placement="bottomLeft">
      <Button type="primary" style={{ maxWidth: 10 }}>
        <TableOutlined style={{ margin: "-6px" }} />
      </Button>
    </Dropdown>
  );
};

export default React.memo(DragAndDropList);
